import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="flex items-center justify-between px-4 py-3 bg-gray-800 border-t border-gray-700 text-sm text-gray-500">
      <span>v1.0.0</span>
      <span className="flex items-center gap-1">
        Made by AAA
      </span>
    </footer>
  );
};
